<template>
  <div class="quicknav">
    <div class="qn_main">
      <!-- 左边部分 -->
      <div class="navleft">
        <!-- logo -->
        <div class="qn_img">
          <img src="/Templets/image/quicknav/logo.svg" alt="">
        </div>
        <!-- 搜索框 -->
        <div class="qn_search">
          <div class="qn_enter">
            <span><a href="https://lib.scujj.edu.cn/" target="_blank">图书馆</a></span>
          </div>
          <input style="text-align: right" placeholder="搜索图书" ref="text" class="qn_input" type="search" />
          <div class="qn_search_icon" id="searchBtn" @click="searchs">
            <img class="pointer" :src="httpurl + '/Templets/image/search.png'" alt="" />
          </div>
        </div>
        <div class="scgov"><img src="https://www.scujj.edu.cn/Templets/image/scgov/scszf.jpg" alt="点击进入">
          <a target="_blank" href="https://www.sc.gov.cn"></a>
        </div>
        <!-- 微信和微博 -->
        <div class="qn_icon">
          <div class="wechat">
            <img src="/Templets/image/quicknav/wechatpng.png" alt="">
            <div class="qrcode">
              <img src="/Templets/image/quicknav/wechat.png" alt="">
            </div>
          </div>
          <div class="line">
            <img src="/Templets/image/quicknav/linepng.png" alt="">
          </div>
          <div class="weibo">
            <img src="/Templets/image/quicknav/weibo.png" alt="">
            <div class="qrcode">
              <a target="_blank" href="https://weibo.com/jinjiangcollege">https://weibo.com/jinjiangcollege</a>
            </div>
          </div>
          <div class="line">
            <img src="/Templets/image/quicknav/linepng.png" alt="">
          </div>
          <span class="gxwllz">
            <a href="javascript:void(0)" onclick="getGXLZ();">高校网络理政</a>
          </span>
        </div>
        <!-- 地址 -->
        <div class="address">地址：四川·彭山·锦江大道一号</div>
        <!-- 邮编 -->
        <div class="code">邮编：620860</div>
      </div>
      <!-- 中间分割线 -->
      <div class="navmiddle">
        <img src="/Templets/image/quicknav/line.png" alt="">
      </div>
      <!-- 右边部分 -->
      <div class="navright">
        <div id="linklist" class="navlist">
          <a href="javascript:void(0)" onclick="getOA();" class="qn_nav active block pointer" target="_blank">OA系统</a>
          <a href="https://jjxymss.scujj.edu.cn/#/" class="qn_nav active block pointer" target="_blank">留言板</a>
          <a href="https://jjxymss.scujj.edu.cn/#/principalMailbox" class="qn_nav active block pointer"
            target="_blank">校长信箱</a>
          <a href="#" class="qn_nav active block pointer" target="_blank"></a>
          <a href="https://xy.scujj.edu.cn/" class="qn_nav active block pointer">校友网</a>
          <a href="/html/page/bgdh.html" class="qn_nav active block pointer">办公电话</a>
          <div class="qn_nav active block pointer one">
            <a href="/html/page/xxxl.html">校历 &nbsp;·&nbsp;</a>
            <a href="/html/page/xyjt.html">交通</a>
          </div>
          <a href="/html/page/xyjt.html" class="qn_nav active block pointer"></a>
          <a href="https://hq.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">后勤服务</a>
          <a href="https://xxzx.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">网络服务</a>
          <a href="https://jwc.scujj.edu.cn" class="qn_nav active block pointer" target="_blank">教务管理系统</a>
          <a href="#" class="qn_nav active block pointer" target="_blank"></a>
          <a href="https://hr.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">人力资源</a>
          <a href="https://jjdjw.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">锦江党建</a>
          <a href="https://xxgk.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">信息公开</a>
          <a href="https://hr.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank"></a>

        </div>
      </div>
      <div class="mobile-navright">
        <a href="javascript:void(0)" onclick="getOA();" class="qn_nav active block pointer" target="_blank">OA系统</a><a
          href="https://jjxymss.scujj.edu.cn/#/" class="qn_nav active block pointer" target="_blank">留言板</a>
        <a href="https://xy.scujj.edu.cn/" class="qn_nav active block pointer">校友网</a><a href="/html/page/bgdh.html"
          class="qn_nav active block pointer">办公电话</a>
        <a href="https://hq.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">后勤服务</a><a
          href="https://xxzx.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">网络服务</a>
        <a href="https://hr.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">人力资源</a><a
          href="https://jjdjw.scujj.edu.cn/" class="qn_nav active block pointer" target="_blank">锦江党建</a>
        <a style="margin-top: 1.2rem!important;" href="https://jjxymss.scujj.edu.cn/#/principalMailbox"
          class="qn_nav active block pointer" target="_blank">校长信箱</a>
        <a style="margin-top: 1.2rem!important;" href="https://xxgk.scujj.edu.cn/" class="qn_nav active block pointer"
          target="_blank">信息公开</a>
        <div class="qn_nav active block pointer one">
          <a href="/html/page/xxxl.html">校历 &nbsp;·&nbsp;</a>
          <a href="/html/page/xyjt.html">交通</a>
        </div>
        <a href="https://jwc.scujj.edu.cn" class="qn_nav active block pointer" target="_blank">教务管理系统</a>
      </div>
    </div>
  </div>
</template>
<script>
// import $ from 'jquery'
export default {
  name: 'footer',
  data () {
    return {}
  },
  mounted () {},
  methods: {
    addJs (str) {
      const s = document.createElement('script')
      s.type = 'text/JavaScript'
      s.src = str
      document.body.appendChild(s)
    },
    searchs () {
      window.open(
        'http://qw.duxiu.com/getPage?ecode=utf-8&channel=getPage&Field=all&sw=' +
          encodeURIComponent(this.$refs.text.value) + '')
    },
    getOA () {
      window.open('http://10.66.0.12:9110/')
    },
    getGXLZ () {
      window.open('http://gxlz.scedu.net/webuser/index.html#/Home')
    }
  }
}
</script>
<style lang="scss" scoped>
.gxwllz {
  font-size: 15px;
  // margin-left: 200px;
  // margin-top: -25px;
  display: block;
  float: right;
  margin-top: 4px;
  color: white;
  vertical-align: text-bottom;

  a {
    list-style: none;
    text-decoration: none;
    color: white;
  }
}

@media screen and (max-width: 768px) {
  .scgov {
    width: 100%;
  }
}

@media screen and (max-width: 640px) {
  .gxwllz {
    font-size: 10px;
    color: white;
    vertical-align: text-bottom;
    margin-left: 0;
    display: inline-block;
    margin-top: 4px;
    transform: scale(.9);
    width: 50%;
  }
}

@media (min-width:1200px) and (max-width:1530px) {
  .gxwllz {
    margin-left: 18px;
    margin-top: -31px;
    transform: scale(.9);
  }

  .line {
    display: inline-block;
    margin: 0 11px;

    img {
      width: auto;
    }
  }

  .weibo {
    position: relative;
    display: inline-block;
    width: 15%;
    height: 100%;
  }
}

.wechat>img {
  width: 29px;
  height: 26px;
}

@media (min-width: 1200px) and (max-width: 1530px) {
  .wechat>img {
    width: 20px;
    height: auto;
  }
}

@media screen and (max-width: 640px) {
  .quicknav {
    // width: 100vw;
    padding: 0;
    padding-top: 20px;

    .qn_main {
      width: 100vw;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 15px;
      padding-top: 20px;

      .navleft {
        width: 47%;
        margin-right: 5px;
        // border: 1px solid white;
        margin: 0;

        .qn_img {
          margin: 0;

          img {
            width: auto;
            height: auto;
          }
        }

        .address {
          line-height: 32px;
          margin: 0;
        }

        .code {
          line-height: 32px;
          margin: 0;
        }

        .qn_search {
          width: 100%;
          height: 24px;
          margin-top: 15px;

          // margin-bottom: 10px;
          img {
            width: 16px;
            height: 16px;
          }
        }

        .qn_enter {
          text-align: right;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        // .qn_input{
        //   width: 100%;
        // }
        .qn_icon {
          width: 100%;
          margin: 0;

          .line {
            height: 12px;
            // margin: 0 0.3rem 0 0.2rem;
            margin: 0;
            width: 2px;
            margin-left: 0.5rem;
            margin-right: 0.5rem;
            margin-top: 7px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .wechat {
          img {
            width: 15px;
            height: auto;
          }
        }

        .weibo {
          img {
            width: 15px;
            height: auto;
          }
        }
      }

      .navmiddle {
        width: 1px !important;
        height: 2rem !important;
        align-self: center;
        margin: 0 0.4rem 0 0.4rem !important;
        display: block;
      }

      .navright {
        // width: 100%;
        // display: block;
        margin: 0;
        padding: 0 0 26px 0;

        .separate {
          margin: 0;

          .qn_nav {
            font-size: 12px;
            width: 50%;
            margin: 0;
            line-height: 28px;
          }
        }
      }

      .mobile-navright {
        display: flex;
        flex-wrap: wrap;
        width: 44%;
        margin-left: 5px;

        .qn_nav {
          display: inline-block !important;
          width: 50% !important;
          margin: 0 !important;
          line-height: 16px !important;
          font-size: 8px !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue